export default __webpack_public_path__ + "static/media/VN.60aa8e6f.png";